import React, { useState } from 'react';
import { CheckIcon, LinkIcon } from './ActionIcons';

const DONE_FLASH_MS = 1500;

/** Copies the current page URL (a shareable report link) to the clipboard. */
const CopyLinkButton: React.FC = () => {
    const [done, setDone] = useState(false);
    const [failed, setFailed] = useState(false);

    const copy = async () => {
        try {
            await navigator.clipboard.writeText(window.location.href);
            setFailed(false);
            setDone(true);
            window.setTimeout(() => setDone(false), DONE_FLASH_MS);
        } catch (err) {
            console.error('Copy link failed:', err);
            setFailed(true);
        }
    };

    const label = failed ? 'Copy failed — try again' : done ? 'Link copied' : 'Copy link to this report';
    return (
        <button
            type="button"
            className={`icon-button${failed ? ' is-error' : ''}`}
            title={label}
            aria-label={label}
            onClick={() => void copy()}
        >
            {done ? <CheckIcon /> : <LinkIcon />}
        </button>
    );
};

export default CopyLinkButton;
